var map = {
	"./bluesky.svg": "./theme/src/icons/bluesky.svg",
	"./close.svg": "./theme/src/icons/close.svg",
	"./envelope.svg": "./theme/src/icons/envelope.svg",
	"./facebook.svg": "./theme/src/icons/facebook.svg",
	"./globe.svg": "./theme/src/icons/globe.svg",
	"./instagram.svg": "./theme/src/icons/instagram.svg",
	"./linkedin.svg": "./theme/src/icons/linkedin.svg",
	"./offsite-link.svg": "./theme/src/icons/offsite-link.svg",
	"./phone.svg": "./theme/src/icons/phone.svg",
	"./search.svg": "./theme/src/icons/search.svg",
	"./twitter.svg": "./theme/src/icons/twitter.svg",
	"./youtube.svg": "./theme/src/icons/youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./theme/src/icons sync recursive \\.svg$";